(function($, undefined) {
	
	'use strict';
	
	var currPage;
	var minElem;
	var secElem;
	var submitFormBtn;
    var backPurchaseBtn;
	var cancelPurchaseBtn;
	var emptyCartBtn;
	var detailFeesBtn;
	var backBtn;
	var shippingBtn;
	var paymentTypeBtn;
    var shippingModeBtn;

	var getTime = function() {
		var url = "/action/epCurrentTimer";

		ajax(url, function(response) {
			if (response.indexOf('-') !== -1) {
				window.location.href = window.location.href;
			} else {
				var min = response.split(':')[0];
				var sec = response.split(':')[1];
	            
	            if(parseInt(sec) < 10){
	                sec = "0"+sec;
	            }

				minElem.html(min);
				secElem.html(sec);
            	timer();
			}
		}, true);
	};
	
	var timer = function(){
		var min = parseInt(minElem.html());
		var sec = parseInt(secElem.html());
		var secStr;
		var minStr;
		
		if(min >= 0){
			if(sec > 0){
				var newSec = sec - 1;
				secStr = newSec < 10 ? "0" + newSec: newSec ;
			} else if(min > 0) {
				minStr = min - 1;
				secStr = "59";
			}
		}
		
		minElem.html(minStr);
		secElem.html(secStr);
		
		if(min !== 0 || (min === 0 && sec > 0)){
			window.setTimeout(timer,1000);
		}
	};
    
    var submitPaymentForm = function(event){
    	$(this).addClass('disabled');
        event.preventDefault();
        var form = $(".payment-process-step");
        formValidator.validateForm(form);
        
        if (!form.hasClass('has-error')) {
            if (form.hasClass('payment-process-step-2')) {
                console.log('calling facebook function Purchase ...............');
                fbq('track', 'Purchase', {currency: "CAD", value: 0.00});
            }
            form.submit();
        } else {            
            $(this).removeClass('disabled');
        }
        
    };
    
    var backPurchase = function(event){
        $("#checkout-back-form").submit();
    };
    var cancelPurchasePopup = function(event){
        event.preventDefault();    
    };
    
    var emptyCart = function(){
        var t = $(this);
        var url = "/action/epAddCart";
        url += "?ajax=true&clear=true";
        ajax(url, function(){
            var redirection = t.attr('data-url');
            window.location.href = redirection;
        }, true);
    };
    
    var toggleFees = function(){
      var t = $(this);  
      
      t.fadeOut();
      
      $(".mini-cart-fees-total").slideDown();
    };
    
    var goBack = function(){
        event.preventDefault();    
        $("#checkout-back-form").submit();
    };
	
//	var updateShippingPrice = function() {
//		var paymentProcessShippingTotal = $('.payment-process-shipping-price');
//		var price;
//
//		if(this.value === '0') {
//			price = paymentProcessShippingTotal.attr('data-free-shipping');
//		} else {
//			price = paymentProcessShippingTotal.attr('data-shipping');
//		}
//		
//		paymentProcessShippingTotal.html(price);
//		// @TODO: Update cart price front-end and shipping price in backend
//	};

	var handlePaymentChoice = function() {
		var t = $(this);
		var ccInputsCtn = $('.credit-card-inputs-ctn');

		if ($('.payment-type-choice .form-check-input:checked').val() === 'cheque') {            
            
			ccInputsCtn.find('.required').each(function() {
				$(this).removeClass('required').addClass('derequired');
//				ccInputsCtn.addClass('hidden');
			});
            ccInputsCtn.slideUp("fast", function () {
                $(".cheque-infos-ctn").fadeIn().addClass('visible');
            });
		} else {
            
			ccInputsCtn.find('.derequired').each(function() {
				$(this).removeClass('derequired').addClass('required');
//				ccInputsCtn.removeClass('hidden');
			});
            $(".cheque-infos-ctn").removeClass('visible').fadeOut("fast", function () {
                ccInputsCtn.slideDown();
            });
		}
	};
    
    var pickShippingMode = function(){
        var t = $(this);
        var merchAddrCtn = $(".virtual-cash-address-box-merch");
        var url = "/action/epManageShippingRules";
        url += "?shippingMode="+t.val();
        url += "&ajax=true";
        ajax(url, function(response){
            var j = response.trim().substring(8); //response = success-
            var json = JSON.parse(j);
            var shipping = json.shipping;
            var subtotal = json.subTotal;
            var total = json.total;
            
            $(".payment-process-shipping-price").text(formatMoney(shipping));
            $(".payment-process-subtotal-price").text(formatMoney(subtotal));
            $(".payment-process-step-1-amount-total-number").text(formatMoney(total));

            if (t.hasClass('pickup')) {
            	$('.shipping-address:not(.element-to-toggle)').slideUp(function() {
            		$('.shipping-address').find('.required').addClass('derequired').removeClass('required').val('').removeClass('error').removeClass('success').closest('.input-ctn').removeClass('focused');
            	});
                if($('.shipping-address.element-to-toggle').length !== 0){                    
            		$('.shipping-address').find('.required').addClass('derequired').removeClass('required').val('').removeClass('error').removeClass('success').closest('.input-ctn').removeClass('focused');
                }
                $(".virtual-cash-address-box-merch").addClass("hide");
            } else {
            	$('.shipping-address:not(.element-to-toggle)').slideDown(function() {
            		$('.shipping-address').find('.derequired').addClass('required').removeClass('derequired');
            	});
                if($('.shipping-address.element-to-toggle').length !== 0){                    
            		$('.shipping-address').find('.derequired').addClass('required').removeClass('derequired');
                }
                merchAddrCtn.removeClass("hide");
                if (merchAddrCtn.find('input[name=firstName]').val() === '' && merchAddrCtn.find('.virtual-cash-address-box-inputs-ctn').css('display') !== 'block') {
                    merchAddrCtn.find('.editable-item-btn').trigger('click');
                }
            }

            if ($(".virtual-cash-step-2-warning-1").length !== 0) {
                $(".virtual-cash-step-2-warning-1").slideUp();
                $(".js-form-error-message").slideUp();
            }
            
        }, true);
    };
    
    
	var init = function (page) {
		currPage = $(page);
		minElem = $(".timer-minutes");
		secElem = $(".timer-sec");
        
        var eventId=$(".payment-process-event-info").data("event-id");
        if(eventId === 6942) { //ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE
            console.log('calling facebook function ............... ERIC LAPOINTE EN FORMULE SOUPER SPECTACLE');
            fbq('init', '438706678514426');
        }
        if(eventId === 7165) { //OBSKUR #004 - Kill The Noise & Friends
            console.log('calling facebook function ............... OBSKUR #004 - Kill The Noise & Friends');
            fbq('init', '943675224110997');
        }
        if(eventId === 7325) { //Thuwan_Test_2_Event_1
            console.log('calling facebook function ............... Thuwan_Test_2_Event_1');
            fbq('init', '266548857543903');
        }
        if(eventId === 7362) { //Thuwan_Test_2_Event_2
            console.log('calling facebook function ............... Thuwan_Test_2_Event_2');
            fbq('init', '1722681941873874');
        }

        if ($(".timer-minutes")[0] && $(".timer-sec")[0]) {
			getTime();
        }
        
        submitFormBtn = $(".submit-process-payment-btn");
        submitFormBtn.on("click", submitPaymentForm);
        
        backPurchaseBtn = $(".back-purchase");
        backPurchaseBtn.on("click", backPurchase);
        
        cancelPurchaseBtn = $(".cancel-purchase-btn");
        cancelPurchaseBtn.on("click", cancelPurchasePopup);
        
        emptyCartBtn = $(".empty-cart-btn");
        emptyCartBtn.on("click", emptyCart);
        
        detailFeesBtn = $(".mini-cart-details-btn");
        detailFeesBtn.on("click", toggleFees);
        
        backBtn = $(".back-purchase");
        backBtn.on("click", goBack);
		
//		shippingBtn = $(".payment-process-radio");
//		shippingBtn.on("change", updateShippingPrice);

		paymentTypeBtn = $('.payment-type-choice .form-check-input');
		paymentTypeBtn.change(handlePaymentChoice);

		shippingModeBtn = $('.payment-process-radio');
		shippingModeBtn.change(pickShippingMode);


		$('.billing-country-select').change(function() {
        	initChangeStates($(this));
		});
        
	};
	
	$(window).on("load",function(){
		init();
	});
})(jQuery);
